import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

function Whatsapp() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    const phoneNumber = '8209745951'; 
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <div
      className="fixed bottom-10 right-10 flex items-center bg-green-500 text-white p-3 rounded-full cursor-pointer shadow-lg hover:bg-green-600 transition duration-300"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <FaWhatsapp size={30} />
      {isHovered && (
        <div className="ml-2">
          <span>Need help? Chat with us</span>
        </div>
      )}
    </div>
  );
}

export default Whatsapp;